import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import {Parts} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Addresses_Object} state
 *  @property {object} model
 *  @property {Customers_Addresses_Properties} model.properties
 *  @property {Customers_Addresses_Is} model.is
 *  @property {Customers_Addresses_Has} model.has
 */
export default class CustomerMilitary extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		military: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Military._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.military;

		if (!data) return;

		let newState = {
			loading: false,
			loaded: true,
		};

		if (this._ismounted) {
			this.model.properties.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.has.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.is.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.setState(newState, () => this.loadSelfAfter(data))
		}

		this.loadSelfAfterAlways();
	};

	form = () => {

		/** @type {Customers_Military_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Military_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title"> Military Address</h4>
					<Parts.Address
						object={object}
						properties={properties}
						onTextUpdate={this.handleTextFieldPropertyUpdate}
						onSelectUpdate={this.handleSelectPropertyUpdate}
						notRequired={true}
					/>
					<h4 className="section-title">Military PCS</h4>
					<div className={"row"}>
						<div className={"col-6"}>
							<div className={"form-group"}>
								<Framework.Elements.TextField
									label={"PCS City"}
									name={"PCS City"}
									value={object.pcs_city}
									property={properties.pcs_city}
									error={object.pcs_city_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-6"}>
							<div className={"form-group"}>
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.pcs_state}
									value={object.pcs_state}
									error={object.pcs_state_error}
									id={'short'}
									model={Types.States._name}
									nullable={true}
									limit={null}

								/>
							</div>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-6"}>
							<div className={"form-group"}>
								<Framework.Elements.Date
									label={"PCS Effective Date"}
									property={properties.pcs_date}
									value={object.pcs_date}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-6"}>
							<div className={"form-group"}>
								<Framework.Elements.TextField
									label={"PCS Order Number"}
									name={"PCS  Order Number"}
									value={object.pcs_order_number}
									property={properties.pcs_order_number}
									error={object.pcs_order_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
